var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMint = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128pt",
    height: "128pt",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00abe6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m64 84c-2.1992 0-4-1.8008-4-4s1.8008-4 4-4h8c2.1992 0 4-1.8008 4-4s-1.8008-4-4-4h-4c0-2.1992-1.8008-4-4-4s-4 1.8008-4 4v0.71875c-4.6406 1.6406-8 6.0391-8 11.281 0 6.6016 5.3984 12 12 12 2.1992 0 4 1.8008 4 4s-1.8008 4-4 4h-8c-2.1992 0-4 1.8008-4 4s1.8008 4 4 4h4c0 2.1992 1.8008 4 4 4s4-1.8008 4-4v-0.71875c4.6406-1.6406 8-6.0391 8-11.281 0-6.6016-5.3984-12-12-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116 16h-12v-4c0-6.6016-5.3984-12-12-12h-56c-6.6016 0-12 5.3984-12 12v4h-12c-6.6016 0-12 5.3984-12 12v36c0 6.6016 5.3984 12 12 12h12v40c0 6.6016 5.3984 12 12 12h56c6.6016 0 12-5.3984 12-12v-28c0-2.1992-1.8008-4-4-4s-4 1.8008-4 4v28c0 2.1992-1.8008 4-4 4h-56c-2.1992 0-4-1.8008-4-4v-60h64v16c0 2.1992 1.8008 4 4 4h16c6.6016 0 12-5.3984 12-12v-36c0-6.6016-5.3984-12-12-12zm-84-4c0-2.1992 1.8008-4 4-4h56c2.1992 0 4 1.8008 4 4v4h-64zm88 52c0 2.1992-1.8008 4-4 4h-12v-12h4c2.1992 0 4-1.8008 4-4s-1.8008-4-4-4h-88c-2.1992 0-4 1.8008-4 4s1.8008 4 4 4h4v12h-12c-2.1992 0-4-1.8008-4-4v-36c0-2.1992 1.8008-4 4-4h104c2.1992 0 4 1.8008 4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.039 32c-2.1992 0-4 1.8008-4 4s1.8008 4 4 4c2.1992 0 4-1.8008 4-4 0-1.1602-0.87891-4-4.0391-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.039 32c-2.1992 0-4 1.8008-4 4s1.8008 4 4 4c2.1992 0 4-1.8008 4-4 0-1.1602-0.87891-4-4.0391-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.04 32c-2.1992 0-4 1.8008-4 4s1.8008 4 4 4c2.1992 0 4-1.8008 4-4 0-1.1602-0.87891-4-4.0391-4z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMint);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mint.0799fff536b83029623cbf0e9c7711a3.svg";